var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6676 9.11959C15.4792 8.93115 15.1893 8.93115 15.0009 9.11959L12.4937 11.6268V5.47826C12.4937 5.21744 12.2763 5 12.0154 5C11.7546 5 11.5371 5.21735 11.5371 5.47826V11.6268L9.04438 9.11959C8.85594 8.93115 8.56612 8.93115 8.37766 9.11959C8.18921 9.30802 8.18923 9.59785 8.37766 9.7863L11.6965 13.1051C11.74 13.1486 11.798 13.1776 11.8559 13.2066C11.8995 13.2356 11.9575 13.2356 12.0155 13.2356C12.0734 13.2356 12.1314 13.2211 12.1893 13.1921C12.2473 13.1631 12.3053 13.1342 12.3488 13.0906L15.6676 9.77175C15.8416 9.61232 15.8415 9.30802 15.6676 9.11959Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5507 16.9997H7.47826C7.21744 16.9997 7 16.7823 7 16.5214V13.449C7 13.1881 7.21735 12.9707 7.47826 12.9707C7.73908 12.9707 7.95652 13.1881 7.95652 13.449V16.0577H16.0725V13.449C16.0725 13.1881 16.2898 12.9707 16.5507 12.9707C16.8115 12.9707 17.029 13.1881 17.029 13.449V16.5214C17.0144 16.7823 16.8115 16.9997 16.5507 16.9997Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.bb67c59af80bdbeb6955973b32e9cd97.svg";
export { ForwardRef as ReactComponent };